import { useAnalyticsInjection } from 'hooks/useAnalyticsInjection';
import React from 'react';
import { Routes } from 'routes/Routes';
import 'styles/styles.scss';

export const App: React.FC = () => {
    useAnalyticsInjection();

    return <Routes />;
};
